import React, { useState, Suspense, useLayoutEffect, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';
import Popup from './PopUp';
import './Popup.css';

// Homepages
const Home = React.lazy(() => import("./components/pages/Home"));
const About = React.lazy(() => import("./components/pages/About"));
const Contact = React.lazy(() => import("./components/pages/Contact"));
const Menu = React.lazy(() => import("./components/pages/Menu"));
const Menu_cn = React.lazy(() => import("./components/pages/Menu_cn"));
const Blog = React.lazy(() => import("./components/pages/Blog"));

// Scroll to Top
const ScrollToTop = withRouter(({ children, location: { pathname } }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return children || null;
});

// 特价菜品数据（用于非周二展示）
const specials = [
  {
    id: 1,
    title: '',
    price: '',
    imgSrc: '/assets/images/SpecialGrand1.jpg',
    largeImgSrc: '/assets/images/SpecialGrand1.jpg', // 没有大图就复用原图
    alt: 'Roasted duck with crispy skin and garnish',
  },
  {
    id: 2,
    title: '',
    price: '',
    imgSrc: '/assets/images/SpecialGrand2.jpg',
    largeImgSrc: '/assets/images/SpecialGrand1.jpg',
    alt: 'Fresh cooked lobster with lemon and herbs',
  },
// 未来可以继续添加，比如：
  // { id: 3, title: 'Steak', price: '35$/lb', imgSrc: '/assets/images/special3.jpg', alt: 'Grilled steak' }
];

const ImageCarousel = ({ items, onImageClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) {
      goNext(); 
    }
    if (touchEndX.current - touchStartX.current > 50) {
      goPrev(); 
    }
  };

  if (!items.length) return null;
  const current = items[currentIndex];

  return (
    <div className="carousel-container">
      <button className="carousel-arrow left" onClick={goPrev} aria-label="Previous">‹</button>
      <div className="carousel-slide"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <img
          src={process.env.PUBLIC_URL + current.imgSrc}
          alt={current.alt}
          className="carousel-image"
          onClick={() => onImageClick(current.imgSrc, current.alt)}
          style={{ cursor: 'pointer' }}
        />
        <div className="carousel-caption">
          <h4>{current.title}</h4>
          <p className="price">{current.price}</p>
        </div>
      </div>
      <button className="carousel-arrow right" onClick={goNext} aria-label="Next">›</button>

      {/* 圆点指示器 */}
      <div className="carousel-dots">
        {items.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(idx)}
          />
        ))}
      </div>
    </div>
  );
};

function App() {
  const [showNotice, setShowNotice] = useState(true);
  const [isTuesday, setIsTuesday] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState({ src: '', alt: '' });

  useEffect(() => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    setIsTuesday(dayOfWeek === 2);
  }, []);

  const openImageModal = (src, alt) => {
    setCurrentImage({ src: process.env.PUBLIC_URL + src, alt });
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isImageModalOpen) {
        closeImageModal();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isImageModalOpen]);

  let popupTitle = '';
  let popupMessage = '';
  let popupChildren = null;

  // if () {
    // popupTitle = 'On Vacation';
    // popupMessage = 'Our restaurant is closed during Sept 20 until Oct 1st';
    // popupChildren = (
    //   <div style={{ fontSize: '1.2em', color: '#2c3e50', marginTop: '15px', fontStyle: 'italic' }}>
    //     We will be back Oct 1st.
    //   </div>
    // );
  // } else {
    popupMessage = '';
    popupChildren = (
      <ImageCarousel
        items={specials}
        onImageClick={openImageModal}
      />
    );
  // }

  return (
    <Router basename="/">
      <Suspense fallback={<div></div>}>
        <ScrollToTop>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/about" component={About} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/menu" component={Menu} />
            <Route exact path="/menu_cn" component={Menu_cn} />
            <Route exact path="/points" component={Blog} />
          </Switch>
        </ScrollToTop>

        {showNotice && (
          <Popup
            title={popupTitle}
            message={popupMessage}
            onClose={() => setShowNotice(false)}
          >
            {popupChildren}
          </Popup>
        )}

        {/* 大图预览 Modal */}
        {isImageModalOpen && (
          <div
            className="image-modal-overlay"
            onClick={closeImageModal}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.85)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 10000,
              cursor: 'pointer',
            }}
          >
            <div
              className="image-modal-container"
              onClick={(e) => e.stopPropagation()}
              style={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                background: 'transparent',
              }}
            >
              <img
                src={currentImage.src}
                alt={currentImage.alt}
                style={{
                  width: 'auto',
                  maxWidth: '100%',
                  maxHeight: '90vh',
                  objectFit: 'contain',
                  borderRadius: '8px',
                  boxShadow: '0 0 20px rgba(0,0,0,0.5)',
                }}
              />
              <button
                onClick={closeImageModal}
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '30px',
                  background: 'white',
                  border: 'none',
                  fontSize: '30px',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  lineHeight: '40px',
                  textAlign: 'center',
                  padding: 0,
                }}
              >
                ×
              </button>
            </div>
          </div>
        )}
      </Suspense>
    </Router>
  );
}

export default App;